import { oldReceipt } from "./old-receipt";
import { newReceipt } from "./new-receipt";
import { newReceiptV3 } from "./new-receipt-v3";
import { FlagsPermissionPrintReceipt } from "@/feature-flags/flags-permission-print-receipt";
import { PrintDataEntitas } from "@/domain/entities/Booking";

export const layoutSection = async (
  params: {
      doc: any;
      bookingType: string;
      accountType: string;
      data: PrintDataEntitas;
      pieceData: any;
      barcode: string;
      vendorRefCode: string;
      barcodeValue: string;
      vendorRefCodeValue: string;
      logo: string;
      shipmentId: string;
      startX: number;
      startY: number;
    },
    language = "id"
  ) => {
  const receiptVersion = FlagsPermissionPrintReceipt.receipt_version.getValue();
  
  if (receiptVersion === "v1") {
    await oldReceipt(params, language);
  } else if (receiptVersion === "v3") {
    await newReceiptV3(params, language);
  } else {
    await newReceipt(params, language);
  }
}
